import cookie from "js-cookie";

// Set in Cookie
export const setCookie = (key, value) => {
    if (typeof window !== "undefined") {
        cookie.set(key, value, {
            expires: 1,
        });
    }
};

// remove from cookie
export const removeCookie = (key) => {
    if (typeof window !== "undefined") {
        cookie.remove(key);
    }
};

// Get from cookie
export const getCookie = (key) => {
    if (typeof window !== "undefined") {
        return cookie.get(key);
    }
};

// Set in localstorage
export const setLocalStorage = (key, value) => {
    if (typeof window !== "undefined") {
        localStorage.setItem(key, JSON.stringify(value));
    }
};

// Remove from localstorage
export const removeLocalStorage = (key) => {
    if (typeof window !== "undefined") {
        localStorage.removeItem(key);
    }
};

// Authenticate user
export const authenticate = (response, next) => {
    setCookie("token", response.access_token);
    next();
};

// Access user info
export const isAuth = () => {
    if (typeof window !== "undefined") {
        const cookieChecked = getCookie("token");
        if (cookieChecked) {
            return JSON.parse(atob(cookieChecked.split('.')[1]));
        } else {
            return false;
        }
    }
};

// Signout
export const signout = (next) => {
    removeCookie("token");
    removeCookie("refresh");
    removeLocalStorage("user");
    next();
};


// ✅ FIXED UTC → IST formatter
export const formatDateTime = (utcString) => {
    if (!utcString) return "";

    let normalizedString = String(utcString).trim();

    // Normalize PostgreSQL timestamp
    if (/^\d{4}-\d{2}-\d{2}/.test(normalizedString)) {
        normalizedString = normalizedString.replace(/(\.\d{3})\d+/, '$1');
        normalizedString = normalizedString.replace(/([+-])(\d{2})(\d{2})$/, '$1$2:$3');
        normalizedString = normalizedString.replace(/^(\d{4}-\d{2}-\d{2})\s+/, '$1T');
        normalizedString = normalizedString.replace(/\s+([+-]\d{2}:\d{2})$/, '$1');

        const hasTimezone = /Z$|[+-]\d{2}:\d{2}$/.test(normalizedString);

        // 👉 KEY FIX: treat as UTC if no timezone
        if (!hasTimezone) {
            normalizedString += "Z";
        }
    }

    const dateObj = new Date(normalizedString);
    if (isNaN(dateObj.getTime())) return utcString;

    // Format (IST automatically handled by browser)
    const day = String(dateObj.getDate()).padStart(2, '0');
    const month = String(dateObj.getMonth() + 1).padStart(2, '0');
    const year = String(dateObj.getFullYear()).slice(-2);

    let hours = dateObj.getHours();
    const minutes = String(dateObj.getMinutes()).padStart(2, '0');
    const ampm = hours >= 12 ? 'PM' : 'AM';

    hours = hours % 12 || 12;

    return `${month}-${day}-${year} ${String(hours).padStart(2, '0')}:${minutes} ${ampm}`;
};